import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/solid';
import { WhatsAppMessage, VCardContact } from '../types';
import { getContactName, isVCardContact } from '../utils';

interface ReplyPreviewProps {
    message: WhatsAppMessage;
    onCancelReply: () => void;
}

const ReplyPreview: React.FC<ReplyPreviewProps> = ({ message, onCancelReply }) => {
    // Function to generate a concise preview text
    const getPreviewText = (msg: WhatsAppMessage): string => {
        if (msg.type === 'chat' && msg.message) {
            return msg.message.length > 50 ? msg.message.substring(0, 47) + '...' : msg.message;
        }
        if (msg.hasMedia) {
            if (msg.type === 'image') return '📷 Изображение' + (msg.message ? `: ${msg.message.substring(0, 30)}...` : '');
            if (msg.type === 'video') return '📹 Видео' + (msg.message ? `: ${msg.message.substring(0, 30)}...` : '');
            if (msg.type === 'audio' || msg.type === 'ptt') return '🎵 Аудио';
            if (msg.type === 'document') return `📄 ${msg.filename || 'Документ'}`;
            return '📎 Вложение';
        }
        if (msg.type === 'location') return '📍 Местоположение';
        if (msg.type === 'vcard') {
            return `👤 Контакт: ${getContactName(msg.vcard)}`;
        }

        return 'Сообщение'; // Fallback
    };

    const previewText = getPreviewText(message);
    const senderName = message.direction === 'outgoing' ? 'Вы' : message.sender || 'Неизвестный';

    return (
        <div className="bg-gray-100 dark:bg-gray-700 p-2 border-t border-b border-gray-300 dark:border-gray-600 flex items-center justify-between text-sm">
            <div className="flex-grow overflow-hidden mr-2">
                <div className="font-semibold text-blue-600 dark:text-blue-400">Ответ {senderName}</div>
                <div className="text-gray-700 dark:text-gray-300 truncate">
                    {previewText}
                </div>
            </div>
            <button
                onClick={onCancelReply}
                className="p-1 text-gray-500 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-100 focus:outline-none"
                aria-label="Отменить ответ"
            >
                <XMarkIcon className="h-5 w-5" />
            </button>
        </div>
    );
};

export default ReplyPreview;
